export default __webpack_public_path__ + "static/m-sizzling2-4cf899b1976ffbaef2677164de6d1014.jpg";